var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.removeWrappingPoints ? 'BCXMarkBeforeWrapped' : 'div',{tag:"component",staticClass:"bc-items-with-points",class:{'is-aligned-right': _vm.isAlignedRight, 'is-aligned-left': !_vm.isAlignedRight, 'is-justified-right': _vm.isJustifiedRight},style:({'--gap': _vm.gap, '--y-gap': _vm.yGap})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }